// assets
import { IconUserSearch, IconUsersGroup, IconUsers } from '@tabler/icons-react';

// constant
const icons = {
    PersonSearch: IconUserSearch,
    Groups3: IconUsersGroup,
    People: IconUsers
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const search = {
    id: 'search',
    title: 'Search',
    type: 'group',
    children: [
        {
            id: 'accountSearch',
            title: 'Account',
            type: 'item',
            url: '/search/account',
            icon: icons.PersonSearch
        },
        {
            id: 'teamSearch',
            title: 'Team',
            type: 'item',
            url: '/search/team',
            icon: icons.Groups3
        },
        {
            id: 'memberSearch',
            title: 'Member',
            type: 'item',
            url: '/search/member',
            icon: icons.People
        }
    ]
};

export default search;
